import { render, staticRenderFns } from "./PhaseAqua.vue?vue&type=template&id=6e6e2cc6&scoped=true"
import script from "./PhaseAqua.vue?vue&type=script&lang=js"
export * from "./PhaseAqua.vue?vue&type=script&lang=js"
import style0 from "./PhaseAqua.vue?vue&type=style&index=0&id=6e6e2cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6e2cc6",
  null
  
)

export default component.exports